const dev = {
  API_ENDPOINT_URL: 'https://localhost/server-b2b/backend/api/mobile/v1/',
  BASE_URL : 'https://localhost/server-b2b/backend/',
  //SOCKET_URL: 'http://localhost:3001',
  DOMAIN_URL: 'https://localhost:3000',
 // SOCKET_URL: 'http://localhost:3001' ,
  SOCKET_URL: 'http://server.cloudlogisitc.com:3001'
};

const test = {
  API_ENDPOINT_URL: 'http://demo_server.cloudlogisitc.com/',
  DOMAIN_URL: 'http://demo_subadmin.cloudlogisitc.com',
  SOCKET_URL: 'http://demo_server.cloudlogisitc.com:3005'
};

const prod = {
  API_ENDPOINT_URL: 'https://lavenderapp.net/backend/api/mobile/v1/',
  DOMAIN_URL: 'backend.lavenderapp.net',
  SOCKET_URL: 'wss://lavenderapp.net/wss2'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
